import { FC } from 'react';
import { FormLabel, Switch } from '@screentone/core';

import { StructureGroupConfig } from 'data/generated/graphql';

interface RegionToggleProps {
  groupConfig: StructureGroupConfig & { id: string };
  checked: boolean;
  onToggle: (enabled: boolean) => void;
}
const RegionToggle: FC<RegionToggleProps> = ({ groupConfig, checked, onToggle }) => {
  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(e.target.checked);
  };

  const label = groupConfig.label ? `Enable ${groupConfig.label}` : `Enable ${groupConfig.id}`;

  return (
    <FormLabel label={label} labelPosition="right">
      <Switch role="switch" name={`enable-${groupConfig.id}`} checked={checked} onChange={handleToggle} />
    </FormLabel>
  );
};

export default RegionToggle;
